module.exports = __webpack_public_path__ + "static/media/insl-logo-white-transparent.e48ee6cb.png";